import {isApiTrue}              from "@Common/logic/is-api-true";
import {ComponentNext, Link}    from "@Common/react/cst2";
import {Types}                  from "@Common/types";
import {chain}                  from "@Common/utils/fs";

import {VariationSelectionState} from "./variations-state";

export const VariationsStock = (
    {
        next,
        templateOptions,
        variationSelectionState: {enabled: variationsEnabled, selection}
    }:{
        next: Link<JSX.Element, {
            allowBackOrder: boolean,
            availableQuantity: number,
            show: boolean,
        }>,
        templateOptions: Types.Apis.Payloads.Next.TemplateOptions.Details.Response,
        variationSelectionState: ComponentNext<typeof VariationSelectionState>
    },
) => next(
    variationsEnabled
    ? chain(
        selection.matchingVariations.length === 1 ? selection.matchingVariations[0] : null,
        (matchedVariation) => ({
            allowBackOrder: isApiTrue(matchedVariation?.product.allow_back_order) ?? false,
            availableQuantity: (
                isApiTrue(matchedVariation?.product.out_of_stock)
                ? 0
                : (matchedVariation?.product.availableQuantity || -1)
            ),
            show: matchedVariation && isApiTrue(
                templateOptions?.options?.find(option => option.devKey === "show_available_stock")?.value
            ),
        }),
    )
    : null
);

